module.exports = __webpack_public_path__ + "static/media/SideMenu_Packages.b615d1fc.svg";